import { render, staticRenderFns } from "./MedicineAgencies.vue?vue&type=template&id=42472c76"
import script from "./MedicineAgencies.vue?vue&type=script&lang=js"
export * from "./MedicineAgencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports